import { assert } from "@/helpers/console.ts";
import type { FC } from "react";
import { styled } from "@linaria/react";

const FileLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: inherit;
  text-decoration: underline;
  word-break: break-word;
`;

const Description = styled.p`
  margin-top: 0.5rem;
  white-space: pre-wrap;
`;

interface FlowMessageFileProps {
  src: string;
  text?: string;
}

export const FlowMessageFile: FC<FlowMessageFileProps> = ({ src, text }) => {
  assert(src.length !== 0, "File src needs to be more than 0");

  const fileName = src.replace(/^.*[\\/]/, "").split("?")[0] || "Uploaded file";

  return (
    <>
      <FileLink href={src} target="_blank" rel="noreferrer">
        {fileName}
      </FileLink>
      {text && text.length > 0 && <Description>{text}</Description>}
    </>
  );
};
